
export type ColumnFormatType = 'text' | 'currency' | 'number' | 'percent' | 'date' | 'chip' | 'icon' | 'boolean' | 'custom';

export interface CurrencyFormatOptions {
  currency?: string;
  display?: string;
  digits?: string;
}

export interface NumberFormatOptions {
  digits?: string;
  locale?: string;
}

export interface DateFormatOptions {
  format?: string;
  locale?: string;
}

export interface ChipFormatOptions {
  colorMap?: Record<string | number, string>;
  defaultColor?: string;
  displayField?: string;
  displayMap?: Record<string | number, string>;
}

export interface IconFormatOptions {
  iconMap?: Record<string | number, string>;
  colorMap?: Record<string | number, string>;
  defaultIcon?: string;
  defaultColor?: string;
  tooltipField?: string;
}

export interface TextFormatOptions {
  transform?: 'uppercase' | 'lowercase' | 'titlecase' | 'none';
  prefix?: string;
  suffix?: string;
  truncate?: number;
  ellipsis?: boolean;
}

export interface BooleanFormatOptions {
  type?: 'icon' | 'text' | 'chip';
  trueText?: string;
  falseText?: string;
  trueIcon?: string;
  falseIcon?: string;
  trueColor?: string;
  falseColor?: string;
}

export type CustomFormatFunction<T = unknown> = (value: unknown, row: T, column: ColumnDef) => string | number;

export interface CustomFormatOptions {
  formatterFn?: string;
}

export interface ColumnDef {
  key: string;
  label: string;
  hideLabel?: boolean;
  always: boolean;
  visible: boolean;
  format?: ColumnFormatType;
  formatOptions?: CurrencyFormatOptions | NumberFormatOptions | DateFormatOptions |
                 ChipFormatOptions | IconFormatOptions | TextFormatOptions |
                 BooleanFormatOptions | CustomFormatOptions;
  cssClass?: string;
  tooltip?: string;
  showTooltip?: boolean;
  tooltipField?: string;
  width?: string;
  sticky?: boolean;
  customTemplate?: string;
  propertyPath?: string[];
  sortable?: boolean;
  ariaLabel?: string;
  align?: 'left' | 'center' | 'right';
  linkTemplate?: string;
}


export interface PageChangeEvent {
  pageIndex: number;
  pageSize: number;
}

export interface RowActionEvent<T> {
  action: string;
  row: T;
}

export interface RowClickEvent<T> {
  row: T;
  event: MouseEvent;
}
